<script>
export default {
  name: "PageTitle",
  props: {
    listOnly: {
      type: Boolean,
      default: false
    }
  },
  computed:{
    page(){ return this.$root.page },    
  }
}
</script>

<template>
  <div class="row page-titles">
    <div class="col-md-5">
      <h4 class="text-themecolor">{{page.PageName||"-"}}</h4>
    </div>
    <div class="col-md-7 tr">
      <div class="btn-group">
        <router-link v-if="page.Name && !page.NoList && !listOnly" :to="{name:page.Name}" class="btn btn-outline-info" v-tooltip="'List '+page.ObjectName">
          <i class="fa fa-list"></i><span> List</span>
        </router-link>
        <router-link v-if="page.AddItem" :to="{name:page.Name,params:{id:'add'}}" class="btn btn-outline-success" v-tooltip="'Add '+page.ObjectName">
          <i class="fa fa-plus"></i><span> Add</span>
        </router-link>
      </div>
    </div>
  </div>
</template>